import APIService from "@/services/APIService.js"; 

export default {
  getMapeamento() {
    return APIService.apiCall().get("/mapeamentos/getMapeamento");
  },
  getAllDatabases(){
    return APIService.apiCall().get(`/mapeamentos/getAllDatabases`); 
  },
  importacaoUsuarios(id){
    return APIService.apiCall().get(`/mapeamentos/importacaoUsuarios/${id}`); 
  },
  editMapeamento(data){
    return APIService.apiCall().post(`/mapeamentos/edit/${data.id}`,JSON.stringify(data)); 
  },
  replicarMapeamento(data){
    return APIService.apiCall().post(`/mapeamentos/replicar/${data.id}`,JSON.stringify(data)); 
  },
  deletarMapeamento(arrayMapeamentos){
    return APIService.apiCall().post(`/mapeamentos/remover`,JSON.stringify(arrayMapeamentos)); 
  }
}